/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../../../Fixes';
import Builder from '../../../../../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "profiles": {
            "nested": {
              "v2": {
                "nested": {
                  "model": {
                    "nested": {
                      "settings": {
                        "nested": {
                          "common": {
                            "nested": {
                              "Tile": {
                                "fields": {
                                  "tileAppearance": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.Tile.TileAppearance",
                                    "id": 1,
                                    "rule": "optional",
                                    "options": {
                                      "default": "IMAGE"
                                    }
                                  }
                                },
                                "nested": {
                                  "TileAppearance": {
                                    "values": {
                                      "UNKNOWN": 0,
                                      "IMAGE": 1,
                                      "TEXT": 2
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.common?.nested?.Tile && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.common?.nested?.Tile?.nested?.TileAppearance) {
  $root.addJSON(jsonData);
}

/**
 * IMPORTANT: When Adding New Fields to Device Profiles, you MUST implement their default values at:
 *
 * /java/device-settings/src/main/java/com/squareup/devicesettings/processing/profiles/v2/defaults
 *
 * ⚠️ WARNING: Fields will not be automatically hydrated unless default values are implemented in the Java code above.
 * This is a mandatory step for all device profile settings.
 *
 * SOURCE Tile @ squareup/devicesettings/profiles/v2/model/settings/common/tile.proto at 17:1
 */
export const Tile = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.common.Tile');
fixType(Tile);
Builder.createAndAttachToType(Tile);
/**
 * SOURCE TileAppearance @ squareup/devicesettings/profiles/v2/model/settings/common/tile.proto at 19:3
 */
Tile.TileAppearance = $root.lookupEnum('squareup.devicesettings.profiles.v2.model.settings.common.Tile.TileAppearance').values;